import { handleActions } from 'redux-actions';
import {
  FINISH_CLOSE_MODAL,
  OPEN_MODAL,
  SET_CHATBOT_TOUR_STEP,
  SET_TOUR,
  START_CLOSE_MODAL,
} from './actions';
import { ModalState } from './interfaces';
import { MODALS_TYPE } from './types';

const initialState: ModalState = {
  modalType: '',
  modalProps: {},
  isOpen: false,
  isOpening: false,
  isTourOpen: false,
  chatbotTour: {
    step: null,
  },
  modalsQueue: [],
};

export const openModal = (state: ModalState, { payload }) => {
  const { modalType, modalProps } = payload;

  // Note: narrowing down putting to the queue only to this case,
  // since we get braking changes in other places if it is generalized,
  // and it it hard to test/catch all possible cases.
  if (
    modalType === MODALS_TYPE.AUDIENCE_EXTRACTOR_MODAL &&
    (state.isOpen || state.isOpening)
  ) {
    return { ...state, modalsQueue: [...state.modalsQueue, payload] };
  }

  return {
    ...state,
    modalType,
    modalProps,
    isOpen: true,
    isOpening: true,
    isTourOpen: false,
  };
};

export const startCloseModal = (state: ModalState, { payload }) => {
  const { modalType } = payload;
  if (modalType && modalType !== state.modalType) {
    return state;
  }
  return { ...state, isOpen: false };
};

export const finishCloseModal = (state: ModalState, { payload }) => {
  const { modalType } = payload;
  if (modalType && modalType !== state.modalType) {
    return state;
  }

  if (state.modalsQueue.length) {
    const [nextAction, ...otherActions] = state.modalsQueue;
    const { modalType, modalProps } = nextAction;

    return {
      ...state,
      modalType,
      modalProps,
      isOpen: true,
      isOpening: true,
      isTourOpen: false,
      modalsQueue: otherActions,
    };
  }
  return { ...initialState, isTourOpen: state.isTourOpen };
};

export const setOpenTour = (state: ModalState, { payload }) => {
  return { ...state, modalType: '', isTourOpen: payload, isOpen: payload };
};

export const setChatbotTourStep = (state: ModalState, { payload }) => ({
  ...state,
  modalType: '',
  chatbotTour: {
    step: payload.step,
    id: payload.id,
  },
  isOpen: !(payload.step === null || payload.step === undefined),
});

const mappedReducers = {
  [START_CLOSE_MODAL]: startCloseModal,
  [FINISH_CLOSE_MODAL]: finishCloseModal,
  [OPEN_MODAL]: openModal,
  [SET_TOUR]: setOpenTour,
  [SET_CHATBOT_TOUR_STEP]: setChatbotTourStep,
};

const modalState = handleActions(mappedReducers, initialState);

export default modalState;
